/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const GET_HISTORICAL_FACTS = gql`
  query GetHistoricalFacts($knowledgeId: ID!, $factIds: [HistoricalFactID!]!) {
    getHistoricalFacts(knowledgeId: $knowledgeId, factIds: $factIds) {
      id
      names
      locations
      dereferencedId
      type
      relations {
        factId
        name
        direction
      }
      value
      descriptions {
        name
        factId
      }
      referenceTo
      isDeleted
      parentFact {
        id
        knowledgeId
        names
        parentFactId
        locations
        value
        owner
        readers
        editors
        referenceTo
        viewUrl
        childProperties
        isDeleted
      }
      parentFactId
    }
  }
`;

export const GET_FACT_VALUE = gql`
  query GetFactValue($knowledgeId: ID!, $factId: ID!, $epoch: Int!) {
    getFact(knowledgeId: $knowledgeId, factId: $factId, epoch: $epoch) {
      id
      knowledgeId
      value
    }
  }
`;

export const GET_FACTS_AT_STEP_PATH = gql`
  query GetFactsAtStepPath($workerId: ID!, $stepPath: [String!]!) {
    getFactsAtStepPath(workerId: $workerId, stepPath: $stepPath) {
      columns
      data
    }
  }
`;

export const GET_FACT = gql`
  query GetFact($knowledgeId: ID!, $factId: ID!, $epoch: Int!) {
    getFact(knowledgeId: $knowledgeId, factId: $factId, epoch: $epoch) {
      id
      knowledgeId
      knowledge {
        id
        owner
        readers
        editors
        name
        description
        departmentId
        workerId
        parentKnowledgeId
        state
        brainVersion
      }
      names
      parentFact {
        id
        knowledgeId
        names
        parentFactId
        locations
        value
        owner
        readers
        editors
        referenceTo
        dereferencedId
        type
        viewUrl
        childProperties
        isDeleted
      }
      parentFactId
      locations
      relations {
        factId
        name
        direction
      }
      value
      descriptions {
        name
        factId
      }
      owner
      readers
      editors
      referenceTo
      dereferencedId
      type
      viewUrl
      childProperties
      isDeleted
    }
  }
`;

export const GET_FACTS = gql`
  query GetFacts($knowledgeId: ID!, $factIds: [ID!]!) {
    getFacts(knowledgeId: $knowledgeId, factIds: $factIds) {
      id
      dereferencedId
      value
      names
    }
  }
`;
